import { History, Location } from 'history';
import { USERNAME } from '../../../../constants/UrlParams';
import { ERROR_CODES } from '../../pages/error/ErrorCodes';
import { navigateToErrorPage } from '../../pages/error/ErrorNavigation';
import { ErrorFlow } from '../../pages/error/ErrorFlow';

export const getUserProvidedUsername = (location: Location) =>
  new URLSearchParams(location.search).get(USERNAME);

export const errorPageAction = (history: History) => (statusCode: number) => {
  let errorCode;
  switch (statusCode) {
    case 422:
      errorCode = ERROR_CODES.MANUAL_REG_SAP_EMAIL_ERROR;
      break;
    case 424:
      errorCode = ERROR_CODES.MANUAL_REG_SAP_CREATE_ERROR;
      break;
    default:
      errorCode = ERROR_CODES.MANUAL_REG_3_POINT_CHECK;
      break;
  }
  navigateToErrorPage(errorCode, ErrorFlow.manualReg, '', history, true);
};
